const regEx =
    /(((https|http){1}(:\/\/)?(www\.)?)|(www\.){1})[-a-z\d@:%._+~#=]{1,256}\.[a-z\d()]{1,15}\b([-a-z\d()@:%_+.~#?&/=]*)/gim

export const getUrlsFromString = (val: string) => {
    return val.match(regEx)
}
